import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './PlanScorecardCompanyLetter.css'

@CSSModules(Styles)
export default class AndrewBeharSignature extends Component {
  render() {
    const andrewBeharSignature = require('../../../static/images/andrew-behar-signature.png')
    //
    return (
      <div>
        <p>Sincerely,</p>
        <img
          src={andrewBeharSignature}
          alt='Andrew Behar'
          styleName='signature-image'
        />
        <p><b>Andrew Behar<br/>
        CEO, As You Sow</b></p>
      </div>
    )
  }
}
